import { render, staticRenderFns } from "./CrmPage.vue?vue&type=template&id=0af9bbfd&"
import script from "./CrmPage.vue?vue&type=script&lang=js&"
export * from "./CrmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports